
import React from "react";
import { TableRow, TableCell } from "@/components/ui/table";
import { Loader2 } from "lucide-react";

interface UserTableEmptyStateProps {
  isLoading: boolean;
}

const UserTableEmptyState: React.FC<UserTableEmptyStateProps> = ({ isLoading }) => {
  if (isLoading) {
    return (
      <TableRow>
        <TableCell colSpan={4} className="text-center py-10">
          <div className="flex justify-center items-center">
            <Loader2 className="h-6 w-6 animate-spin mr-2" />
            <span>Cargando usuarios...</span>
          </div>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow>
      <TableCell colSpan={4} className="text-center py-10">
        No hay usuarios registrados
      </TableCell>
    </TableRow>
  );
};

export default UserTableEmptyState;
